var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.ehUsuarioFornecedor && _vm.canAccessDashFornecedor)?_c('dashboard-fornecedor'):_c('dashboard-funcionario-varejo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }